export default __webpack_public_path__ + "static/media/bg2.0559c9e2.jpg";